module.exports = __webpack_public_path__ + "img/aicon11.3ec47968.png";